var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"loading-overlay"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overlay-content"},[_c('img',{attrs:{"src":require("@/assets/img/Spin-1s-200px.gif"),"alt":""}})])
}]

export { render, staticRenderFns }